import React from 'react';
import intl from 'react-intl-universal';
import classNames from 'classnames';
import EmailIcon from '@material-ui/icons/Email';
import CellPhoneIcon from '@material-ui/icons/PhoneAndroid';
import RegularPhoneIcon from '@material-ui/icons/Phone';
import PrintIcon from '@material-ui/icons/Print';
import LocationIcon from '@material-ui/icons/LocationOn';
import moment from 'moment';

export default function CasesEmployeePres({ applicant, viewType, isCorpClient, onUpdateView, onEmail }) {
  const avatarURL = process.env.PUBLIC_URL + '/images/avatar-placeholder.svg';
  const expiryDate = '(' + intl.get('cases.details.expires') + ' ' + moment(new Date(applicant.visaExpiration)).format('MMMM DD') + ')';
  const applicantEmail = applicant.email ? applicant.email.toLowerCase() : '';

  return (
    <section className="cases-employee-applicant">
      <div className="employee-header">
        <div className="employee-header-avatar">
          <img src={avatarURL} border="0" alt="Person profile" />
        </div>
        <div className="employee-header-name">
          <span className="employee-fullname">
            {applicant.firstName} {applicant.lastName}
          </span>
          <span className="employee-applicantype">{applicant.applicantType}</span>
        </div>
      </div>

      <div className="employee-tabs">
        <div className="employee-tabs-header">
          <a
            className={classNames({ 'employee-tabs-details': true, active: viewType === 'details' })}
            onClick={onUpdateView.bind(null, 'details')}>
            <span className="employee-tab-title">{intl.get('cases.details.employeeDetails')}</span>
            <span className="hide-bottom-border" />
          </a>
          <a
            className={classNames({ 'employee-tabs-dependents': true, active: viewType === 'dependents' })}
            onClick={onUpdateView.bind(null, 'dependents')}>
            <span className="employee-tab-title">
              {intl.get('cases.details.employeeDependents')} ({applicant.dependentCount})
            </span>
            <span className="hide-bottom-border" />
          </a>
        </div>

        <div className="employee-tab-content">
          <div className={classNames({ 'employee-details-content': true, active: viewType === 'details' })}>
            <div className="details-content-top-wrapper">
              <div className="top-item">
                <div className="item-icon">
                  <CellPhoneIcon />
                </div>
                <div className="item-text">{applicant.mobile}</div>
              </div>
              <div className="top-item">
                <div className="item-icon">
                  <EmailIcon />
                </div>
                <div className="item-text">
                  <a className="item-email" onClick={onEmail.bind(null, applicantEmail)}>
                    {applicantEmail}
                  </a>
                </div>
              </div>
              <div className="top-item">
                <div className="item-icon">
                  <RegularPhoneIcon />
                </div>
                <div className="item-text">{applicant.phone}</div>
              </div>
              <div className="top-item">
                <div className="item-icon">
                  <LocationIcon />
                </div>
                <div className="item-text">
                  {applicant.city}, {applicant.state} | {applicant.country}
                </div>
              </div>
              <div className="top-item">
                <div className="item-icon">
                  <PrintIcon />
                </div>
                <div className="item-text">{applicant.fax}</div>
              </div>
            </div>

            <div className="details-content-bottom-wrapper">
              <div className="bottom-item">
                <div className="item-label">{intl.get('cases.details.employeeDetailsTab.age')}</div>
                <div className="item-value">{applicant.age}</div>
              </div>
              <div className="bottom-item">
                <div className="item-label">{intl.get('cases.details.employeeDetailsTab.relationship')}</div>
                <div className="item-value">{applicant.relationship}</div>
              </div>
              <div className="bottom-item">
                <div className="item-label">{intl.get('cases.details.employeeDetailsTab.nationality')}</div>
                <div className="item-value">{applicant.nationality}</div>
              </div>
              <div className="bottom-item">
                <div className="item-label">{intl.get('cases.details.employeeDetailsTab.inmigrationStatus')}</div>
                <div className="item-value">
                  {applicant.immigrationStatus}
                  <span className={classNames({ 'visa-expiry': true, [applicant.visaExpirationMessageColour.toLowerCase()]: true })}>
                    {expiryDate}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className={classNames({ 'employee-dependents-content': true, active: viewType === 'dependents' })}>
            {applicant.dependents.map(dependent => {
              const country =
                dependent.countryOfCitizenship.length && dependent.countryOfCitizenship[0] ? dependent.countryOfCitizenship[0] : '';
              const dob = dependent.dateOfBirth && moment(new Date(dependent.dateOfBirth)).format('MM/DD/YY');

              return (
                <div className="dependent-row" key={dependent.firstName + dependent.lastName}>
                  <div className="avatar-cell">
                    <img src={avatarURL} border="0" alt="Person profile" />
                  </div>
                  <div className="name-cell">
                    <span className="cell-fullname">
                      {dependent.firstName} {dependent.lastName}
                    </span>
                    {!isCorpClient && (
                      <span className="cell-dob">
                        {country} - {intl.get('cases.details.employeeDependandDOB')}: {dob}
                      </span>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/ui/features/Cases/presentational/CasesEmployeePres.js